/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
export const PAGINATION = {
    pagination: {
        labelRowsPerPage: 'Files per pàgina', 
        labelDisplayedRows: ({ from, to, count }) =>
        `${from} - ${to} de ${count}`, 
    }
}
const M_FILTRES = 'Mostra filtres';
export const GRID_DEFAULT_LOCALE_TEXT = {
    
    
    // Root
    noRowsLabel: 'No hi ha files',
    noResultsOverlayLabel: "No s'han trobat resultats.",
    errorOverlayDefaultLabel: 'Ha ocorregut un error.',
  
    // Density selector toolbar button text
    toolbarDensity: 'Densitat',
    toolbarDensityLabel: 'Densitat',
    toolbarDensityCompact: 'Compacta',
    toolbarDensityStandard: 'Estàndard',
    toolbarDensityComfortable: 'Comfortable',
  
    // Columns selector toolbar button text
    toolbarColumns: 'Columnes',
    toolbarColumnsLabel: 'Selecciona columnes',
  
    // Filters toolbar button text
    toolbarFilters: 'Filtres',
    toolbarFiltersLabel: M_FILTRES,
    toolbarFiltersTooltipHide: 'Amaga filtres',
    toolbarFiltersTooltipShow: M_FILTRES,
    toolbarFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtres actius` : `${count} filtre actiu`,
  
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: 'Busca…',
    toolbarQuickFilterLabel: 'Busca',
    toolbarQuickFilterDeleteIconLabel: 'Neteja',
  
    // Export selector toolbar button text
    toolbarExport: 'Exporta',
    toolbarExportLabel: 'Exporta',
    toolbarExportCSV: 'Descarrega com a CSV',
    toolbarExportPrint: 'Printa',
    toolbarExportExcel: 'Descarrega com a Excel',
  
    // Columns panel text
    columnsPanelTextFieldLabel: 'Troba una cloumna',
    columnsPanelTextFieldPlaceholder: 'Títol de la comlumna',
    columnsPanelDragIconLabel: 'Reordena la columna',
    columnsPanelShowAllButton: 'Mostra-ho tot',
    columnsPanelHideAllButton: 'Amaga-ho tot',
  
    // Filter panel text
    filterPanelAddFilter: 'Afegeix filtre',
    filterPanelDeleteIconLabel: 'Suprimeix',
    filterPanelLinkOperator: 'Operador logic',
    filterPanelOperators: 'Operador', // TODDO v6: rename to filterPanelOperator
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columnes',
    filterPanelInputLabel: 'Valor',
    filterPanelInputPlaceholder: 'Filtrar valor',
  
    // Filter operators text
    filterOperatorContains: 'conté',
    filterOperatorEquals: 'igual',
    filterOperatorStartsWith: 'comença amb',
    filterOperatorEndsWith: 'acaba amb',
    filterOperatorIs: 'està',
    filterOperatorNot: 'no està',
    filterOperatorAfter: 'està despres',
    filterOperatorBefore: 'està abans',
    filterOperatorIsEmpty: 'està buit',
    filterOperatorIsNotEmpty: 'no està buit',
    filterOperatorIsAnyOf: 'es qualsevol de',
  
    // Filter values text
    filterValueAny: 'cap',
    filterValueTrue: 'cert',
    filterValueFalse: 'fals',
  
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Mostra columnes',
    columnMenuFilter: 'Filtra',
    columnMenuHideColumn: 'Amaga',
    columnMenuUnsort: 'Desordena',
    columnMenuSortAsc: 'Ordena per ASC',
    columnMenuSortDesc: 'Ordena per DESC',
  
    // Column header text
    columnHeaderFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtres actius` : `${count} filtre actiu`,
    columnHeaderFiltersLabel: M_FILTRES,
    columnHeaderSortIconLabel: 'Ordena',
  
    // Rows selected footer text
    footerRowSelected: (count) =>
      count !== 1
        ? `${count.toLocaleString()} files sel·leccionades`
        : `${count.toLocaleString()} fila sel·leccionada`,
  
    // Total row amount footer text
    footerTotalRows: 'Files totals:',
  
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount) =>
      `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,
  
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Sel·lecció de capsa',
    checkboxSelectionSelectAllRows: 'Sel·lecciona totes les files',
    checkboxSelectionUnselectAllRows: 'Desel·lecciona totes les files',
    checkboxSelectionSelectRow: 'Sel·lecciona fila',
    checkboxSelectionUnselectRow: 'Desel·lecciona fila',
  
    // Boolean cell text
    booleanCellTrueLabel: 'si',
    booleanCellFalseLabel: 'no',
  
    // Actions cell more text
    actionsCellMore: 'més',
  
    // Column pinning text
    pinToLeft: "Fixa a l'esquerra",
    pinToRight: 'Fixa a la dreta',
    unpin: 'Desfixa',
  
    // Tree Data
    treeDataGroupingHeaderName: 'Agrupa',
    treeDataExpand: 'veure fills',
    treeDataCollapse: 'amaga fills',
  
    // Grouping columns
    groupingColumnHeaderName: 'Agrupa',
    groupColumn: (name) => `Agrupa per ${name}`,
    unGroupColumn: (name) => `Deixa d'agrupar per ${name}`,
  
    // Master/detail
    detailPanelToggle: 'Activa el panell de detall',
    expandDetailPanel: 'Expandeix',
    collapseDetailPanel: 'Contrau',
  
    // Used core components translation keys
    MuiTablePagination: {},
  
    // Row reordering text
    rowReorderingHeaderName: 'Reordenament de files',
  
    // Aggregation
    aggregationMenuItemHeader: 'Agregació',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'mida',
  };